/**
 * Detect and recover from webpack / @loadable/component chunk load failures.
 * Common after deployments when a long-lived tab requests removed chunk files.
 */

const RELOAD_FLAG_PREFIX = 'coachify-chunk-reload';

export const isChunkLoadError = error => {
  if (!error) {
    return false;
  }
  const name = error.name || '';
  const message = error.message || String(error);
  return (
    name === 'ChunkLoadError' ||
    /loading chunk [\w-]+ failed/i.test(message) ||
    /chunkloaderror/i.test(message)
  );
};

export const clearChunkReloadFlag = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(`${RELOAD_FLAG_PREFIX}:${window.location.pathname}`);
  } catch (_) {
    /* ignore */
  }
};

/**
 * Reload the page once per pathname to fetch fresh index.html and chunk manifest.
 * @returns {boolean} true if a reload was triggered
 */
export const tryReloadOnceForChunkError = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const key = `${RELOAD_FLAG_PREFIX}:${window.location.pathname}`;
    const alreadyReloaded = sessionStorage.getItem(key);
    if (!alreadyReloaded) {
      sessionStorage.setItem(key, '1');
      window.location.reload();
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
};
